import TextField from '@mui/material/TextField';
import { productProperties } from '../../BookingsCalendarTypes';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import * as React from 'react';

type ProductPropertyFilterLabels = {
    productProperties: string;
    propertyTitle: (key: string) => string;
};

type ProductPropertyFilterProps = {
    labels: ProductPropertyFilterLabels;
    onChangeSelectedProperties: (selectedProductProperties: number[]) => void;
    selectedProductProperties: number[];
};

// TODO: Keep local state and expose callback, too slow updates right now.
export function ProductPropertyFilter({
    labels,
    onChangeSelectedProperties,
    selectedProductProperties
}: ProductPropertyFilterProps) {
    const gelLabelByPropertyValue = (targetValue: any) => {
        const foundProperty = productProperties.find((property) => property.value === targetValue);
        return foundProperty ? labels.propertyTitle(foundProperty.label) : null;
    };

    const handleOptionToggle = (value) => () => {
        const currentIndex = selectedProductProperties.indexOf(value);
        const newSelectedProperties = [...selectedProductProperties];

        if (currentIndex === -1) {
            newSelectedProperties.push(value);
        } else {
            newSelectedProperties.splice(currentIndex, 1);
        }

        onChangeSelectedProperties(newSelectedProperties);
    };

    return (
        <TextField
            select
            label={labels.productProperties}
            id="advanced-regions-properties"
            aria-label="advanced-regions-properties"
            value={selectedProductProperties}
            onChange={(event: any) => onChangeSelectedProperties(event.target.value)}
            sx={{ marginRight: '8px', width: '250px' }}
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => {
                    const selectedLabels = selected.map((selectedProperty: any) => {
                        const label = gelLabelByPropertyValue(selectedProperty);
                        return label || '';
                    });

                    return selectedLabels.join(', ');
                },
                MenuProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    }
                }
            }}
        >
            {productProperties.map((property) => {
                return (
                    <MenuItem key={property.value} value={property.value}>
                        <Checkbox
                            checked={selectedProductProperties.indexOf(property.value) > -1}
                            onClick={handleOptionToggle(property)}
                        />
                        <ListItemText primary={gelLabelByPropertyValue(property.value)} />
                    </MenuItem>
                );
            })}
        </TextField>
    );
}
